import {Component, type PropsWithChildren, Suspense} from "react";
import {QueryErrorResetBoundary, useQueryErrorResetBoundary} from "@tanstack/react-query";

function fixErrorValues(key: string, value: unknown): unknown {
    if(key == "auth" || key == "password") return undefined
    return value
}

class ErrorBoundary extends Component<PropsWithChildren<{reset: ()=>unknown}>, {hasError: boolean, error?: unknown}> {
    constructor(props: PropsWithChildren<{reset: ()=>unknown}>) {
        super(props);
        this.state = {hasError: false};
    }

    static getDerivedStateFromError(error: unknown) {
        return {hasError: true, error};
    }

    reset() {
        this.setState({hasError: false});
        this.props.reset();
    }

    render() {
        if (this.state.hasError) {      // You can render any custom fallback UI
            return <>
                <h1>Something went wrong.</h1>
                <button onClick={()=>this.reset()}>Reset</button>
                <pre style={{whiteSpace: "pre-wrap"}}>
                    {typeof this.state.error === 'string' && this.state.error}
                    {typeof this.state.error === 'object' && JSON.stringify(this.state.error, fixErrorValues)}
                </pre>
            </>;
        }
        return <>
            {this.props.children}
        </>;
    }
}

export function SuspenseLayer({children}: PropsWithChildren) {
    const resetQuery = useQueryErrorResetBoundary()
    return <QueryErrorResetBoundary>
        {({reset}) => (
            <ErrorBoundary reset={() => {
                reset()
                resetQuery.reset()
            }}>
                <Suspense fallback={<div>Loading...</div>}>
                    {children}
                </Suspense>
            </ErrorBoundary>
        )}
    </QueryErrorResetBoundary>
}
